import React from 'react';
import { SheetPropsWithActions } from '@kite-js/experimental/lib/Sheet/types';
import { Box, FullScreenSheet, Icon, Typography } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap, selectWhitelabelConfigFromBootstrap } from 'store/slice/bootstrap';
import { WhiteLabelThemeProvider } from 'app/WhiteLabelThemeProvider';

interface OwnProps {
    onClose: () => void;
    headerContent?: React.ReactNode;
    visible: boolean;
}

type Props = OwnProps & Omit<SheetPropsWithActions, 'header' | 'onClose' | 'closeButton'>;

export const CustomSheet: React.FC<Props> = ({ children, headerContent, onClose, ...props }) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const whitelabelConfig = useSelector(selectWhitelabelConfigFromBootstrap);
    return (
        <FullScreenSheet data-testid="activities-custom-sheet" {...props} onClose={onClose}>
            <WhiteLabelThemeProvider whiteLabelId={whitelabelConfig.whiteLabelId}>
                <Box data-testid="activities-custom-sheet-header" as="header" width="100%" maxHeight={headerContent ? '120px' : '56px'} boxShadow="bottom-m" zIndex={5} mb="16">
                    <Box display="flex" flexDirection="row" alignContent="flex-start" px="24" py="16">
                        <Box
                            data-testid="activities-custom-sheet-close-button"
                            data-element-name="activities-custom-sheet-close-button"
                            as="button"
                            width="fit-content"
                            onClick={onClose}
                            p="0"
                            pe="12"
                        >
                            <Icon id="fill.arrow.thin-left" size="20" label={cms[126815]} />
                        </Box>
                        <Typography variant="heading-default">{cms[126799]}</Typography>
                    </Box>
                    <div data-testid="activities-custom-sheet-header-content">{headerContent}</div>
                </Box>
                {children}
            </WhiteLabelThemeProvider>
        </FullScreenSheet>
    );
};

CustomSheet.displayName = 'CustomSheet';
